
import React, { useEffect, useState } from 'react'
import { TextSM } from '../../../../Components/Text/NormalText';
import NuDate from '../../../../Components/Utils/NuDate';
import { Link, useParams } from 'react-router-dom';
import { NewPill } from '../../../../Components/Utils/StatusPills';
import ViewIcon from '../../../../Components/Icons/ViewIcon';
import ViewEquipmentsClient from '../../../Web/Client Management/Clients/EquipmentView';
import { Modal } from 'antd';
import axiosInstance from '../../../../Services/axiosCommon';
import { useFormik } from 'formik';
import * as yup from "yup";
import useEditFormData from '../../../../Components/Hooks/useEditFormData';
import EditIcon from '../../../../Components/Icons/Edit';
import UseGetDataSearchlist from '../../../../Components/Hooks/useFetchDataByListing';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { NuInputWithError } from '../../../../Components/Utils/Input';
import { CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import UsecatEquipDD from '../../../../Components/Hooks/UseCatEquipDD';
import DeleteIcon from '../../../../Components/Icons/Delete';


function EquipmentCard({ item,getData,clientViewId,data,isLoading }) {
      const { contractsViewId, id } = useParams();
      const [showEditDialog, setShowEditDialog] = useState(false);
      const [editEquipmentId, setEditEquipmentId] = useState(null);
    
        const [isViewModalOpen, setIsViewModalOpen] = useState(false); // View modal state
    const { value: unit, getData: refunit } = useFetchMataData(
    "/dropdown/dropdown-details/",
    "unit_equipments"
  );

    const [searchequipment, setSearchequipment] = useState("");
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [categories, setCategories] = useState([]);
    const [searcheCat, setSearcheCat] = useState("");
  
     const [viewModalData, setViewModalData] = useState(null);
    
                      const openViewModal = (data) => {
                        setViewModalData(data);
                        setIsViewModalOpen(true);
                      };
  const { editFormData } = useEditFormData();
const { data: equipmentOptions, setData: setEquipmentOptions } = UsecatEquipDD(
    "/equipments/drop-down",
    searchequipment,
    selectedCategoryId
  );
                       const Editformik = useFormik({
                          initialValues: {
                            id: "",
                            equipmentId: "",
                            unit: "",
                            quantity: "",
                            categoryId: "",
                          },
                          validationSchema: yup.object(
                            {
                            categoryId: yup.string().required("Category is required!"),
                            equipmentId: yup.string().required("Equipment is required!"),
                            unit: yup.string().required("Unit is required!"),
                            quantity: yup.number()
                              .required("Quantity is required!")
                              .min(1, "Quantity must be at least 1"),
                          }
                        ),
                          onSubmit: async (values, { resetForm }) => {
                            const editData = {
                              equipmentId: values.equipmentId,
                              unit: values.unit,
                              quantity: values.quantity,
                              categoryId: values.categoryId,
                              contractId: contractsViewId
                            };
                            
                            const success = await editFormData({
                              url: `/equipment-details/edit-equipment/${values.id}`,
                              formData: editData,
                              navigateUrl: `/Contract-management/contracts/equipments/${contractsViewId}`,
                              resetForm,
                            });
                            
                           
                              setShowEditDialog(false);
                              // resetForm();
                              // refreshEquipmentData();
                              getData()
                            
                          },
                        });

                       const openEditModal = async (data) => {
    try {
      // Fetch the specific equipment details
      const response = await axiosInstance.get(`/equipment-details/equipment/${data.id}`);
      const equipmentData = response.data.data;
      
      // Set the form values
      Editformik.setValues({
        id: equipmentData.id,
        equipmentId: equipmentData.equipmentId,
        unit: equipmentData.unit,
        quantity: equipmentData.quantity,
        categoryId: equipmentData.categoryId,
      });
      
      setEditEquipmentId(equipmentData.id);
      setShowEditDialog(true);
    } catch (error) {
      console.error("Error fetching equipment details:", error);
    }
  };
   
// useEffect(() => {
//     setSelectedCategoryId(formik.values.categoryId);
//   }, [formik.values.categoryId]);

    useEffect(() => {
    setSelectedCategoryId(Editformik.values.categoryId);
  }, [Editformik.values.categoryId]);

   const filteredCategories = categories.filter((item) =>
    item.label.toLowerCase().includes(searcheCat.toLowerCase())
  );


  const closeEditDialog = () => {
    setShowEditDialog(false);
    Editformik.resetForm();
    setEditEquipmentId(null);
  };

   const [refreshData, setRefreshData] = useState(0);
    const refreshEquipmentData = () => {
      setRefreshData(prev => prev + 1);
    };

  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
  
    const handleDeleteClick = (id) => {
      setDeleteId(id);
      setShowDeleteConfirm(true);
    };
  
    const cancelDelete = () => {
      setShowDeleteConfirm(false);
      setDeleteId(null);
    };

      const confirmDelete = async () => {
    try {
      await axiosInstance.delete(`/equipment-details/delete-equipment/${deleteId}`);
      refreshEquipmentData(); // refresh list
    } catch (error) {
      console.error("Error deleting equipment:", error);
    } finally {
      setShowDeleteConfirm(false);
      setDeleteId(null);
    }
  };
  

    return (

        <>
        <div className="w-full border bg-white rounded-lg shadow-xl mt-4 mb-2">
   
        <div className="flex justify-between bg-[#ECEBF3]  rounded-t-lg items-center px-4 py-2">
          <p className=" w-auto h-auto   flex justify-center font-medium text-mainColor-500 items-center text-[12px] rounded-lg">
            {item?.id || "#"}
          </p>
          <div className=" flex items-center gap-3">
            <div className="flex items-center gap-2 overflow-hidden">
              {item?.status &&
               
                  <NewPill text={item?.status} />
              
                }
            </div>
              <Link   to={`/Contract-management/contracts/equipments/${contractsViewId}/details/${item.id}`}
                                state={{
                                  data: data,
                                  from: `/Contract-management/contracts/equipments/${contractsViewId}`,
                                }}>
                                        <ViewIcon color="#048178" height={14} />
                                      </Link>
                                      <Link onClick={() => openEditModal(item)}>
                                        <EditIcon color="#048178" height={14} />
                                      </Link>
                                          <button
            onClick={() => handleDeleteClick(item.id)}
            type="button"
            className="text-red-500 cursor-pointer border-none"
          >
            <DeleteIcon color="red" height={14} />
          </button>
          </div>
        </div>
        <div className=" px-2 pb-2">
          <div className=" px-2 w-full h-8 mt-2 truncate  overflow-hidden">
            <Link
            className="hover:text-blue-600 text-mainColor-400 font-semibold text-[12px] lg:text-[12px] xl:text-[12px] w-full flex justify-between items-center"
                           onClick={() => openViewModal(item)}

            >
              {item?.equipmentName || "-"}
            </Link>
          </div>
          <div
            className="w-full flex justify-between items-center flex-wrap gap-2 mb-2 rounded-md p-2"
            style={{ border: "1px solid #C0C0C0" }}
          >
            {/* <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Ref. : " || "-"} />
                <div className=" text-xs ">{item?.refNumber || "-"}</div>
              </div>
            </div> */}
            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Unit : " || "-"} />
                <div className=" text-xs ">{item?.unit || "-"}</div>
              </div>
            </div>
            {/* <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Brand : " || "-"} />
                <div className=" text-xs ">{item?.brand || "-"}</div>
              </div>
            </div> */}
            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Quantity : " || "-"} />
                <div className=" text-xs ">{item?.quantity || "-"}</div>
              </div>
            </div>
            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Category : " || "-"} />
                <div className=" text-xs ">{item?.categoryName || "-"}</div>
              </div>
            </div>
  
            {/* <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"InspectionDate : " || "-"} />
                <div className=" text-xs ">
                  {(item?.inspectionDate != "None" && (
                    <NuDate value={item?.inspectionDate} format="DD-MMM-YY" />
                  )) ||
                    "-"}
                </div>
              </div>
            </div> */}
  
           
          </div>
        </div>
      </div>

{isViewModalOpen && (       
    <Modal
    open={isViewModalOpen}
    onCancel={()=>setIsViewModalOpen(false)}
    title={"View Equipment"}
    width="50%"
    centered
       className="my-modal"
 
    footer={[]}
  >
    <ViewEquipmentsClient data={viewModalData} open={isViewModalOpen} onCancel={() => setIsViewModalOpen(false)} />
</Modal>
  )}

{showEditDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h2 className="text-xl mb-4">Edit Equipment</h2>
            <form onSubmit={Editformik.handleSubmit}>
              <div className=" grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                {/* <SelectProductWithError
                  type="text"
                  label="Category"
                  placeholder="Category"
                  Options={filteredCategories}
                  formik={Editformik}
                  name="categoryId"
                  width="w-full z-10"
                  // ErrMessage={Editformik.errors.categoryId}
                  px="0"
                  // handleClick={togglePopupCat}
                  setSearch={setSearcheCat}
                  FixPosition={true}
                  PortalTarget={false}
                /> */}
                 <FormikSelectTwo
                Options={filteredCategories}
               label="Category"
                placeholder="Choose"
                
                formik={Editformik}
                name="categoryId"
                width="w-full "
                px='0'
              />

                {/* <SelectProductWithError
                  type="text"
                  label="Equipment"
                  placeholder="Equipment"
                  Options={equipmentOptions}
                  formik={Editformik}
                  name="equipmentId"
                  width="w-full z-9"
                  // ErrMessage={Editformik.errors.equipmentId}
                  px="0"
                  // handleClick={togglePopupEqupiment}
                  setSearch={setSearchequipment}
                  FixPosition={true}
                  PortalTarget={false}
                  disabled={!Editformik.values.categoryId}
                /> */}
                <FormikSelectTwo
                Options={equipmentOptions}
               label="Equipment"
                placeholder="Choose"
                
                formik={Editformik}
                name="equipmentId"
                width="w-full "
                px='0'
              />
<FormikSelectTwo
                Options={unit}
               label="Unit"
                placeholder="Choose"
             
                formik={Editformik}
                name="unit"
                width="w-full "
                px='0'
              />
                {/* <DropDownAddUnitWithError
                  label="Unit"
                  placeholder="Choose"
                  Options={unit}
                  formik={Editformik}
                  name="unit"
                  width="w-full"
                  getFunc={refunit}
                  displayProperty={"Add Unit"}
                  propertyName={"unit_equipments"}
                  // ErrMessage={Editformik.errors.unit}
                  FixPosition={true}
                  PortalTarget={false}
                /> */}
                <NuInputWithError
                  label="Quantity"
                  type="number"
                  formik={Editformik}
                  placeholder="Quantity"
                  name="quantity"
                  width="w-full"
                  // ErrMessage={Editformik.errors.quantity}
                />
              </div>
              <div className="flex justify-end gap-2">
                <CancelButton handleClick={closeEditDialog} />
                <SubmitButton isLoading={isLoading} />
              </div>
            </form>
          </div>
        </div>
      )}

      {showDeleteConfirm && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-auto">
            <h3 className="text-sm font-medium mb-4">Warning</h3>
            <p className="mb-6 text-xs">
              Are you sure you want to delete this equipment?
            </p>
            <div className="flex justify-end space-x-3">
              <button
                onClick={cancelDelete}
                className="px-4 py-[8px] text-xs hover:bg-gray-300 rounded-md bg-[#E6F2F2] text-textColor-main"
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                className="px-4 py-[8px] text-xs bg-textColor-main rounded-md text-white hover:opacity-90"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

</>
    );

    
  }

export default EquipmentCard
